// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@guestsupply/XDL/types";
import { getSystemColor } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

const _sharedNestedListStyles = `
    padding: 0 20px;
    margin: 0;
    & ul, & ol {
        margin: 34px 0;
    }
`;

export default {
    defaultProps: {
        css: css`
            ul,
            ol {
                padding: 0 20px;
                margin: 0;
            }
        `,
    },
    unorderedListProps: {
        css: css`
            ${_sharedNestedListStyles}
        `,
    },
    orderedListProps: {
        css: css`
            & ol {
                list-style-type: lower-alpha;
            }
            ${_sharedNestedListStyles}
        `,
    },
    listItemProps: {
        css: css`
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0;
            color: ${getSystemColor("text.main")};
            line-height: 21px;
            margin: 16px 0;
        `,
    },
} as xBaseTheme["lists"];
